import {ListTableDataSourceFragment} from "../shared/ListTableDataSourceFragment";
import {AbstractListItemsLoader, BaseListItem} from "../shared/types";
import {TableDataRow} from "../shared/TableDataContainer";
import {TableDataSourceFragmentProps, TableDataSourceFragmentState} from "../shared/TableDataSourceFragment";

export type BaseJobListTableDataSourceFragmentState = TableDataSourceFragmentState & {}

export class BaseJobListTableDataSourceFragment<T extends BaseListItem, D extends TableDataRow, L extends AbstractListItemsLoader<T>, P extends TableDataSourceFragmentProps = TableDataSourceFragmentProps, S extends BaseJobListTableDataSourceFragmentState = BaseJobListTableDataSourceFragmentState> extends ListTableDataSourceFragment<T, D, L, P, S> {
}